import { useEffect, useState } from "react"
import { getRolById, postRol, patchRol } from "../../services/RolesServices"
import { getAccionesRolesLista } from "../../services/AccionesRolesServices"
import { RolesFormContext } from "./RolesContext"
import { useNavigate, useParams } from 'react-router-dom';

export const RolesFormState = ({ children }) => {
    const [report, setReport] = useState({})
    const navigate = useNavigate();
    const { id } = useParams()

    useEffect(() => {
        if (id) getRolByIdData(id)
    }, [])

    const getRolByIdData = async (id) => {
        let res = await getRolById(id)
        if (res) setReport(res)
    }

    const postRolData = async (body) => {
        const res = await postRol(body)
        if (res) navigate("/Roles");
    }

    const patchRolData = async (id, body) => {
        const res = await patchRol(id, body)

        if (res) navigate("/Roles");
    }


    return <RolesFormContext.Provider value={{
        report,
        postRolData,
        patchRolData,
    }} >
        {children}
    </RolesFormContext.Provider>
}